import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box, Card, CardContent, Typography, Divider, List, ListItem, CircularProgress
} from '@mui/material';
import { quizService } from '../../services/api';

const ResultDetails = () => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { quiz_id, courseId } = useParams();

  useEffect(() => {
    const fetchQuizResults = async () => {
      try {
        const response = await quizService.getResultDetails(quiz_id);
        console.log(response, "Response");
        const fetchedQuestions = Array.isArray(response.data.questions)
          ? response.data.questions
          : [];
        setQuestions(fetchedQuestions);
        setLoading(false);
      } catch (err) {
        setError('Failed to load quiz results');
        setLoading(false);
      }
    };
    fetchQuizResults();
  }, [quiz_id, courseId]);

  if (loading) return <Box textAlign="center" mt={4}><CircularProgress /></Box>;
  if (error) return <Box textAlign="center" mt={4}><Typography color="error">{error}</Typography></Box>;

  return (
    <Box sx={{ maxWidth: '1000px', mx: 'auto', p: 3 }}>
      <Card variant="outlined" sx={{ borderRadius: 2 }}>
        <CardContent>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {questions.length > 0 ? questions[0].name : 'Quiz Results'}
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {questions.map((que, index) => {
            let correct_ans = [];
            let user_ans = [];

            const user_ans_ary = que.user_answers || [];

            // ✅ collect correct answers
            if (Array.isArray(que.answer_option)) {
              que.answer_option.forEach((ans) => {
                if (ans.is_correct_answer === 1) {
                  correct_ans.push(ans.answer_text);
                }
              });
            }

            // ✅ collect user's selected answers (multiple answers handle)
            if (user_ans_ary.length > 0) {
              user_ans = user_ans_ary.map(u => {
                const matched = que.answer_option.find(opt => opt.id === u.answer_id);
                return matched ? matched.answer_text : u.answer_text || 'Skipped';
              });
            }

            // ✅ Check status (compare sorted arrays)
            const isCorrect =
              user_ans.length > 0 &&
              user_ans.sort().join(',') === correct_ans.sort().join(',');

            return (
              <Box key={que.q_id} sx={{ mb: 3 }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {index + 1}. {que.question_text}
                </Typography>

                <List dense sx={{ pl: 2 }}>
                  {Array.isArray(que.answer_option) && que.answer_option.map((ans) => (
                    <ListItem key={ans.id} sx={{ pl: 2 }}>
                      {ans.answer_text}
                    </ListItem>
                  ))}
                </List>

                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: '0.875rem',
                    mt: 0.5
                  }}
                >
                  <Typography variant="body2" sx={{ color: 'black', mr: 2 }}>
                    <b>Correct Answer:</b> {correct_ans.join(', ') || '-'}
                  </Typography>

                  <Typography variant="body2" sx={{ color: 'black', mr: 2 }}>
                    <b>Your Answer:</b> {user_ans.length > 0 ? user_ans.join(', ') : 'Skipped'}
                  </Typography>

                  <Box
                    sx={{
                      display: 'inline-block',
                      color: 'black',
                      px: 2,
                      py: 0.5,
                      borderRadius: '12px',
                      fontWeight: 'bold',
                      fontSize: '0.875rem',
                      mt: 0.5
                    }}
                  >
                    <b>Status: </b>
                    {isCorrect
                      ? <span style={{ color: 'green' }}>Right</span>
                      : <span style={{ color: 'red' }}>Wrong</span>}
                  </Box>
                </Box>
                <Divider sx={{ my: 2 }} />
              </Box>
            );
          })}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ResultDetails;
